import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

type DeleteKeyDateArguments = OpalApiRequestParams<'DeleteKeyDateV3'>

export async function deleteKeyDate(
  params: DeleteKeyDateArguments
): Promise<null> {
  const url = new URL(
    `/loupe/v3/key_dates/${params.path.key_date_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
